export default function Editable({ page, field, as: Tag = 'span', className, style, children, ...rest }) {
  return <Tag className={className} style={style} {...rest}>{children}</Tag>;
}
